import api from '../../api'

export const sendContact = (fields) => api.post('/cms/contact_messages', fields)
